module.exports = __webpack_public_path__ + "static/img/公众号 拷贝.fd24f6ae.png";